import constMap from '../../const/const';
import { getMsg, isEmpty, isUndefined } from '../../util/util';
import { focusBack, frDelect, goto } from '../../util/isd-utils';
import { getRequireFlg } from '../../util/directive-utils';
import dialogService from '../../services/common/dialogService';
import rootScope from '../../store/rootScopeStore';
import stateStore from '../../store/stateStore';
const create = (valueObj) => {
    const footer = valueObj;
}

const checkDisabled = (isDisabled, requireDisabled) => {
    if (isDisabled || requireDisabled) return true;
    return false;
}

const functionnamekeyDisp = (name, isMobile) => {
    const shortcut = constMap.btnShortcut[name];
    let backString = typeof shortcut === 'object' ? shortcut[rootScope.pageType] : shortcut;
    if (isUndefined(backString) || isMobile) backString = "";
    else backString = `( ${backString} )`;
    return name + backString;
};

const createView = () => {
    const frDelectResult = rootScope.currentPage === "top" ? 'F' : frDelect(rootScope.currentPage);
    // const frDelectResult = 'F';
    let view = null;
    // 入力系、帳票系で表示を分岐
    switch (frDelectResult) {
        case 'F':
            view = constMap.btnView.cancel;
            rootScope.pageType = 'F';
            break;
        case 'R':
            view = constMap.btnView.end;
            rootScope.pageType = 'R';
            break;
        default:
            view = null;
            rootScope.pageType = null;
            break;
    }
    return view;
}

// フッターのクリアボタンデフォルト定義
const footerClearBtnDef = {
    func: () => {
        if (rootScope.footer?.clearBtn && rootScope.footer?.clearBtn.func)
            return rootScope.footer.clearBtn.func();
    }
};
// フッターの終了ボタンデフォルト定義
const footerEndBtnDef = {
    func: () => {
        // OKファンクション
        const okFunc = () => {
            // 変更フラグを初期化
            rootScope.editFlg = false;
            // 画面を閉じる。
            goto('Menu');
        }
        // キャンセルファンクション
        const cancelFunc = () => {
            // フォーカスを元の項目に移動する。
            focusBack();
            return;
        }
        // 終了ボタン確認なしフラグ判定
        if (rootScope.footer.noEndBtnConfirm) {
            // 終了ボタン確認なしフラグが設定されている場合はすぐに終了
            okFunc();
        } else {
            // 確認ダイアログ表示
            dialogService.confirmDialog(rootScope.Message["WCMN0041"][0],getMsg(rootScope.Message["WCMN0041"][0]), "", okFunc, cancelFunc);
        }
    },
    view: createView()
};
// フッターの確定ボタンデフォルト定義
const footerSubmitBtnDef = {
    func: () => {
        // コミット処理が設定されている場合
        if (rootScope.footer.commitBtn && rootScope.footer.commitBtn.func) {
            const view = "";
            // 削除、取消は画面によってモードの値が違うのでモード名で判定
            // angular.forEach($rootScope.header.links, function (header) {
            //     if ($rootScope.header.screenId == header.screenId && $rootScope.header.url == header.url) {
            //         view = header.view;
            //     }
            // });
            // モードが削除、取消の場合のみ確認ダイアログを出す
            if (view == "削除" || view == "取消") {
                // const delMsgId = isNotEmpty($rootScope.header.deleteMsgId) ? $rootScope.header.deleteMsgId : constMap.messageId.commit;
                const delMsgId = '';
                dialogService.confirmDialog(delMsgId, null, null, okFunc, null, null, null, true);
            } else {
                okFunc();
            }
            function okFunc() {
                // 変更フラグを初期化
                rootScope.editFlg = false;
                // 非同期処理(API呼出し)が実行されていない場合はそのまま実行
                rootScope.footer.commitBtn.func();
            }
        }
    }
};

const isDisabled = () => {
    setTimeout(() => {
        const pageMenuContainer = document.body.querySelector('.page-menu-container');
        if (!pageMenuContainer) return;
        const btnCommit = pageMenuContainer.querySelector('.page-menu-btn-commit');
        const clearBtn = pageMenuContainer.querySelector('.page-menu-btn-clear');
        const btnOtherList = pageMenuContainer.querySelectorAll('.page-menu-btn-other');
        const requireDisabledFlg = getRequireFlg();
        if (requireDisabledFlg) {
            isdFooter.setDisabled([btnCommit, btnOtherList]);
        } else {
            isdFooter.removeDisabled([btnCommit, btnOtherList]);
            if (isdFooter.checkDisabled(rootScope.footer.commitBtn?.commitBtnDisabledFlg, rootScope.footer.commitBtn?.requireDisabled)) {
                isdFooter.setDisabled([btnCommit]);
            }
            if (btnOtherList && btnOtherList.length) {
                for (let i = 0; i < btnOtherList.length; i++) {
                    if (isdFooter.checkDisabled(stateStore.getState(rootScope.footer.otherBtn[i].disabled), rootScope.footer.otherBtn[i]?.requireDisabled)) {
                        isdFooter.setDisabled([btnOtherList[i]]);
                    }
                }
            }
        }
        if (clearBtn) {
            rootScope.footer.clearBtn.clearBtnDisabledFlg ? isdFooter.setDisabled([clearBtn]) : isdFooter.removeDisabled([clearBtn]);
        }
    }, 200);
}

const setDisabled = (obj) => {
    obj.forEach(item => {
        if (!item) return;
        if (!NodeList.prototype.isPrototypeOf(item)) {
            item.setAttribute('disabled', 'disabled');
        } else {
            item.forEach(element => {
                element.setAttribute('disabled', 'disabled');
            })
        }
    })
}
const removeDisabled = (obj) => {
    obj.forEach(item => {
        if (!item) return;
        if (!NodeList.prototype.isPrototypeOf(item)) {
            item.removeAttribute('disabled');
        } else {
            Object.values(item).forEach(element => {
                element.removeAttribute('disabled');
            })
        }
    })
}

const disabledBtn = (btn, disabled) => {
    switch (btn) {
        case 'clearBtn':
            const clearBtn = document.body.querySelector('page-menu-btn-clear');
            if (clearBtn) {
                disabled ? clearBtn.setAttribute('disabled', 'disabled') : clearBtn.removeAttribute('disabled');
            }
            break;
        case 'commitBtn':
            const requireDisabledFlg = getRequireFlg();
            if (!requireDisabledFlg) {
                const commitBtn = document.body.querySelector('page-menu-btn-commit');
                if (commitBtn) {
                    disabled ? commitBtn.setAttribute('disabled', 'disabled') : commitBtn.removeAttribute('disabled');
                }
            }
            break;
        default:
            break;
    }


}

const isdFooter = {
    create,
    disabledBtn,
    functionnamekeyDisp,
    setDisabled,
    removeDisabled,
    checkDisabled,
    isDisabled,
    footerClearBtnDef,
    footerEndBtnDef,
    footerSubmitBtnDef
}

export default isdFooter;